"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BasePublicService = void 0;
var tslib_1 = require("tslib");
var base_service_1 = require("../base-service");
var constants_1 = require("../constants");
var BasePublicService = /** @class */ (function (_super) {
    tslib_1.__extends(BasePublicService, _super);
    function BasePublicService(authorization, baseUrl) {
        return _super.call(this, constants_1.PUBLIC_API_URL, authorization, baseUrl) || this;
    }
    return BasePublicService;
}(base_service_1.BaseService));
exports.BasePublicService = BasePublicService;
//# sourceMappingURL=base-public-service.js.map